











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';

@Component({components: {List}})
export default class PreClosingMeetingRemaining extends Vue {
  @Prop() readonly group!: any;

  @Watch('listSection', {immediate: true, deep: true})
  onData2() {
    this.onData();
  }

  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get listSection(): ListSection {
    return dokument.getItem(1506) as ListSection;
  }

  get hidden(): boolean {
    return this.listSection.Hidden === true;
  }
}
